import React from "react";

const brands = [
  { name: "Cfafo", logo: "/tournadologo.png" },
  { name: "GOEV", logo: "/goev.svg" },
  { name: "FurryLove", logo: "/furryyy.png" },
  { name: "Thinkle", logo: "/thinklee.png" },
  { name: "Indimove", logo: "/indimovee.png" },
  { name: "Tournado", logo: "/blippilogo.png" },
  { name: "BigRig Training", logo: "/bigriglogo.png" },
  { name: "MaxxPak", logo: "/maxlogo.png" },
  { name: "AutoGTG", logo: "/autologo.png" },
  { name: "Maxzeego", logo: "/maxzee.svg" },
  { name: "Hike", logo: "/hike.webp" },
];

const Section4 = () => {
  return (
    <section className="py-16 bg-white overflow-hidden">
      <div className="max-w-6xl mx-auto px-4 text-center">
        <p className="text-sm font-semibold text-[#666666] mb-8">
          Delivering solutions to global brands
        </p>

        <div className="relative w-full pt-8">
          <div className="flex  px-12 gap-12 animate-marquee whitespace-nowrap">
            {brands.map((brand, idx) => (
              <div key={idx} className="flex-shrink-0 flex items-center justify-center w-40">
                <img
                  src={brand.logo}
                  alt={brand.name}
                  className="h-[50px] object-contain"
                />
              </div>
            ))}
            {/* Duplicate for seamless loop */}
            {brands.map((brand, idx) => (
              <div key={`dup-${idx}`} className="flex-shrink-0 flex items-center justify-center w-40">
                <img
                  src={brand.logo}
                  alt={brand.name}
                  className="h-[50px] object-contain"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Section4;
